import React from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { FormLabelProps } from '@dreamai/types';

/**
 * Custom Form.Label component for our DSL
 */
const FormLabelComponent: React.FC<FormLabelProps> = ({
  value,
  htmlFor,
  ...props
}) => {
  return (
    <ReactBootstrap.Form.Label htmlFor={htmlFor} {...props}>
      {value}
    </ReactBootstrap.Form.Label>
  );
};

export default FormLabelComponent;
